import React, { useState } from 'react';
import GoUpBtn from '../../common/GoUpBtn';
import { classIf, getConfiguration } from '../../data/utils';
import { getLabel } from '../../InitData';
import { useUISettings } from '../../UISettingsProvider';
import LastMinutePanel from './LastMinutePanel';
import SoffiataPanel from './SoffiataPanel';
import TopMatchPanel from './TopMatchPanel';

const TOP_MATCHES = 1;
const LAST_MINUTE = 2;
const SOFFIATA = 3;

function Widgets(props) {
    const uiSettings = useUISettings();
    const data = props.data;

    const conf = getConfiguration();
    const topMatchesEnabled = (conf?.['tme'] ?? true) && data?.topMatches != null;
    const lastMinuteEnabled = (conf?.['lme'] ?? true) && data?.lastMinute != null;
    const soffiataEnabled = (conf?.['bwe'] ?? true) && data?.soffiata != null;

    const [active, setActive] = useState(() => {
        let active = 1;
        switch (true) {
            default:
            case topMatchesEnabled:
                active = TOP_MATCHES;
                break;
            case lastMinuteEnabled:
                active = LAST_MINUTE;
                break;
            case soffiataEnabled:
                active = SOFFIATA;
                break;
        }
        return active;
    });

    return (
        <>
            {!uiSettings.fullScreen && 
                <div id="secondo-blocco-sport" className="sport-blocco secondo-blocco-sport tablesCompacted destra-top-match go-up-arrow-on-overflow">
                    <GoUpBtn />
                    <div className="scheda-top-match-nav bg-nero bianco maiuscolo nav nav-tabs" role="tablist" id="nav-top-match">
                        {topMatchesEnabled &&
                            <a className={"padding-verticale" + classIf(active === TOP_MATCHES, 'active')} href="#tab-1" data-toggle="tab" role="tab" onClick={() => setActive(1)}>
                                <i className="fas fa-trophy"></i> {getLabel('prematch_page.widget.top_match')}
                            </a>
                        }
                        {lastMinuteEnabled &&
                            <a className={"padding-verticale" + classIf(active === LAST_MINUTE, 'active')} href="#tab-2" data-toggle="tab" role="tab" onClick={() => setActive(2)}>
                                <i className="fas fa-bolt"></i> {getLabel('prematch_page.widget.last_minute')}
                            </a>
                        }
                        {soffiataEnabled &&
                            <a className={"padding-verticale" + classIf(active === SOFFIATA, 'active')} href="#tab-3" data-toggle="tab" role="tab" onClick={() => setActive(3)}>
                                <i className="far fa-smile-wink"></i> {getLabel('prematch_page.widget.la_soffiata')}
                            </a>
                        }
                    </div>
                    <div className="tab-content">
                        {active === TOP_MATCHES && data &&
                            <TopMatchPanel data={data.topMatches} />
                        }
                        {active === LAST_MINUTE && data &&
                            <LastMinutePanel {...data.lastMinute} />
                        }
                        {active === SOFFIATA && data &&
                            <SoffiataPanel data={data.soffiata} />
                        }
                    </div>
                </div>
            }
        </>
    );
}

export default Widgets;
